export const GET_HOUSES_REQUEST = 'resources/houses/GET_HOUSES_REQUEST'
export const GET_HOUSES_SUCCESS = 'resources/houses/GET_HOUSES_SUCCESS'
export const GET_HOUSES_ERROR = 'resources/houses/GET_HOUSES_ERROR'

export const FETCH_HOUSE_REQUEST = 'resources/houses/FETCH_HOUSE_REQUEST'
export const FETCH_HOUSE_SUCCESS = 'resources/houses/FETCH_HOUSE_SUCCESS'
export const FETCH_HOUSE_FAILURE = 'resources/houses/FETCH_HOUSE_FAILURE'
